import { formatParamsGet, getDataFromServer } from "../util";

export const getCustomerBelowId = async (userId) => getDataFromServer("GET", `/management/customer/below/${userId}`, null, true);

export const getUserHierarchy = async () => getDataFromServer("GET", "/management/users/hierarchy", null, true);

export const getUserBelowById = async (userId) => getDataFromServer("GET", `/management/user/below/${userId}`, null, true);

export const getUserFinancials = async (userId) => getDataFromServer("GET", `/management/user-financials/${userId}`, null, true);

export const getUserFinancialsReceived = async (userId) => getDataFromServer("GET", `/management/user-financials-received/${userId}`, null, true);

export const getUserFinancialsRecommender = async (userId) => getDataFromServer("GET", `/management/user-financials-recommender-received/${userId}`, null, true);

export const listAgentCustomersFinancialSummary = async (params) => {
  const strParams = formatParamsGet(params);
  return getDataFromServer("GET", `/management/agents/customers/financial-summary${strParams}`, null, true);
};

export const getManagementSummary = async () => getDataFromServer("GET", `/management/management-summary`, null, true);

export const getAgentSummary = async () => getDataFromServer("GET", `/management/agent-summary`, null, true);

export const getUsersBelow = async (params) => {
  const strParams = formatParamsGet(params);
  return getDataFromServer("GET", `management/users/below${strParams}`, null, true);
};

export const getAgentsBelow = async (id, includeCurrentUser) => {
  const includeCurrentUserParam = includeCurrentUser ? `?includeCurrentUser=${includeCurrentUser}` : "";
  return getDataFromServer("GET", `/management/user/agents/below/${id}${includeCurrentUserParam}`, null, true);
};

export const getUsersBelowTarget = (params) => getDataFromServer("GET", `management/users/below/agents${params}`, null, true);

export const getUsersAboveUser = async (userId) => getDataFromServer("GET", `management/users/above/${userId}`, null, true);
